module.exports = __webpack_public_path__ + "img/nfans.b4c4945a.svg";